import Box from 'components/shared/Box'
import styled from 'styled-components'
import { Color, TextVariant } from 'styles/types'

interface InlineTextListSeparatorProps {
    variant: TextVariant
    color?: Color
}

export const InlineTextListSeparator = styled(
    Box
)<InlineTextListSeparatorProps>`
    display: inline;

    font-size: ${({ theme, variant }) =>
        theme.textVariants[variant].fontSizeMobile}px;
    line-height: ${({ theme, variant }) =>
        theme.textVariants[variant].lineHeightMobile}px;
    font-family: ${({ theme, variant }) =>
        theme.textVariants[variant].fontFamily};
    color: ${({ color, theme, variant }) => {
        const defaultColor = variant?.includes('heading')
            ? theme.colors.grayscale_900
            : theme.colors.grayscale_500
        return color ? theme.colors[color] : defaultColor
    }};
`
